import dayjs from 'dayjs';
import { z } from 'zod';
import { FilterConditionsModel } from '../_models/local-storage';

/**
 * @example
 * generateSearchAccordionOpenSettingKey('project') // project-search-accordion-open-setting
 * generateSearchAccordionOpenSettingKey('project', ['distribution-request', 'expenditure-cart']) // project.distribution-request.expenditure-cart-search-accordion-open-setting
 */
export const generateSearchAccordionOpenSettingKey = (
  featureName: string,
  nests?: string[],
) => {
  return `${featureName}${nests?.length ? `.${nests?.join('.')}` : ''}-search-accordion-open-setting`;
};

export const getSearchAccordionOpenSettingModel = <T extends z.AnyZodObject>(
  valueModel: T,
) => {
  return z.record(z.string().uuid(), valueModel).optional();
};

/**
 * @example
 * generateSearchHistoryKey('project') // project-search-history
 * generateSearchHistoryKey('project', ['distribution-request', 'expenditure-cart']) // project.distribution-request.expenditure-cart-search-history
 */
export const generateSearchHistoryKey = (
  featureName: string,
  nests?: string[],
) => {
  return `${featureName}${nests?.length ? `.${nests?.join('.')}` : ''}-search-history`;
};

export const generateHistoryDateTime = () => {
  return dayjs().format('YYYY/MM/DD HH:mm:ss');
};

export const getFilterHistoryModel = () => {
  return z
    .object({
      datetime: z.string(),
      filterConditions: FilterConditionsModel,
    })
    .array();
};

export const getFilterHistoryStorageModel = <
  T extends z.ZodArray<z.AnyZodObject>,
>(
  filterHistoryModel: T,
) => {
  return z.record(z.string().uuid(), filterHistoryModel);
};
